import { render } from "./NavigationCartComponent.vue?vue&type=template&id=a5d95b36"
import script from "./NavigationCartComponent.vue?vue&type=script&lang=js"
export * from "./NavigationCartComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__